module.exports = __webpack_public_path__ + "static/media/linkdin.20703458.png";